import React, { useState } from 'react';
import { X, Move, MapPin, Layers, Save, Search, List, Calendar } from 'lucide-react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import api from './axiosConfig';
import UniversalLookup from './UniversalLookup';

const MoveAssetModal = ({ isOpen, onClose, asset, onRefresh }) => {
    const { t } = useTranslation();
    const [lookup, setLookup] = useState({ isOpen: false, title: '', type: '', domainId: '', field: '', onCustomSelect: null });
    const [fieldMaps, setFieldMaps] = useState({}); // ???? ?? ????? ?? ???? DOMAINs
    const [formData, setFormData] = useState({
        assetnum: asset?.assetnum,
        new_location: asset?.location || '',
        new_parent: asset?.parent || '',
        new_bin: asset?.bin || '',
        memo: '' // ????? ????????? ??? ?????? ???????
    });

    if (!isOpen) return null;

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSmartSearch = (fieldName, title, defaultType, onCustomSelect = null) => {
        const linkedDomain = (fieldMaps || {})[fieldName];
        setLookup({
            isOpen: true,
            title,
            type: linkedDomain ? 'DOMAIN' : defaultType,
            domainId: linkedDomain || '',
            field: fieldName,
            onCustomSelect: onCustomSelect
        });
    };

    const handleMove = async () => {
        // ???? ?? ??? assetnum ????? ??? undefined
        if (!asset?.assetnum) {
            toast.error(t('moveAsset.errAssetMissing'));
            return;
        }

        const loadId = toast.loading(t('moveAsset.executing'));
        try {
            const payload = {
                assetnum: asset.assetnum, // ????? ?? ???? ????? ???? ???????? ??????
                new_location: formData.new_location,
                new_parent: formData.new_parent,
                new_bin: formData.new_bin,
                memo: formData.memo
            };
    
            console.log("?? Move Payload:", payload); // ??? Debug ???? ???? ?????? ??? ?????
    
            await api.post('/api/assets/move', payload);
            toast.success(t('moveAsset.success'), { id: loadId });
            if (onRefresh) onRefresh();
            onClose();
        } catch (err) {
            console.error("? Move Error Details:", err.response?.data);
            toast.error(err.response?.data?.detail || t('moveAsset.failed'), { id: loadId });
        }
    };

    return (
        <div className="fixed inset-0 z-[10005] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-300">
            {/* ???? ????? ?????? */}
            <UniversalLookup
                {...lookup}
                onClose={() => setLookup({ ...lookup, isOpen: false })}
                onSelect={(row) => {
                    // 1. ??????: ?? ????? ??????? ?? ???? ????? ???????
                    const selectedVal = row.assetnum || row.location_id || row.value || row.id;
                    
                    if (lookup.field === 'new_parent' && selectedVal === asset?.assetnum) {
                        toast.error(t('moveAsset.errOwnParent'), {
                            style: { fontWeight: 'bold', fontSize: '12px' }
                        });
                        return; // ???? ??????? ??? ????? ????? ?? ???? ????? ???? ????
                    }
            
                    // 2. ?? ????? ??? ??????? ??????
                    if (lookup.onCustomSelect) {
                        lookup.onCustomSelect(row);
                    } else {
                        handleInputChange(lookup.field, selectedVal);
                    }
                    setLookup(prev => ({ ...prev, isOpen: false }));
                }}
            />

            <div className="bg-surface-panel w-[550px] shadow-2xl border border-line rounded-sm flex flex-col overflow-hidden">

                {/* Header - IBM Blue */}
                <div className="bg-primary-dark text-ink-inverse p-3 flex justify-between items-center shadow-md">
                    <div className="flex items-center gap-2">
                        <Move size={18} className="text-ink-inverse/70" />
                        <div className="flex flex-col">
                            <span className="font-black text-[11px] uppercase tracking-tighter">{t('moveAsset.title')}</span>
                            <span className="text-[9px] text-ink-inverse/70 font-bold uppercase italic">ID: {asset?.assetnum}</span>
                        </div>
                    </div>
                    <button onClick={onClose} className="hover:bg-status-danger p-1 rounded transition-colors text-ink-inverse">
                        <X size={20} />
                    </button>
                </div>

                <div className="p-5 space-y-5">
                    {/* Current Context Strip - Read Only */}
                    <div className="bg-surface-card border border-line p-3 rounded-sm shadow-sm grid grid-cols-2 gap-4">
                        <div className="border-r border-line-subtle pr-4">
                            <p className="text-[9px] font-black text-ink-secondary uppercase tracking-widest mb-1">{t('moveAsset.currentLocation')}</p>
                            <p className="text-primary font-black text-xs italic">{asset?.location || t('moveAsset.unassigned')}</p>
                        </div>
                        <div className="pl-2">
                            <p className="text-[9px] font-black text-ink-secondary uppercase tracking-widest mb-1">{t('moveAsset.currentParent')}</p>
                            <p className="text-primary font-black text-xs italic">{asset?.parent || t('moveAsset.topLevel')}</p>
                        </div>
                    </div>

                    {/* New Assignments Form */}
                    <div className="bg-surface-card border border-line p-5 space-y-6 shadow-inner relative overflow-hidden">
                        <div className="absolute top-0 right-0 p-1 bg-accent-soft text-accent text-[8px] font-black uppercase">{t('moveAsset.modificationEntry')}</div>

                        {/* New Location with Search */}
                        <EditableField
                            label={t('moveAsset.newLocation')}
                            value={formData.new_location}
                            onChange={(val) => handleInputChange('new_location', val)}
                            onSearch={() => handleSmartSearch('new_location', t('moveAsset.newLocation'), 'locations')}
                            icon={<MapPin size={14} className="text-primary" />}
                            desc={t('moveAsset.targetLocationId')}
                        />

                        {/* New Parent with Search */}
                        <EditableField
                            label={t('moveAsset.newParentAsset')}
                            value={formData.new_parent}
                            onChange={(val) => handleInputChange('new_parent', val)}
                            onSearch={() => handleSmartSearch(
                                'new_parent',
                                t('moveAsset.assetsLookupExcluding'),
                                'assets',
                                null, // No custom select
                                `assetnum_not=${asset?.assetnum}` // ????? ?? ??? API ????? ??????? ??
                            )}
                            icon={<Layers size={14} className="text-accent" />}
                        />

                        {/* Reason / Memo */}
                        <div className="flex flex-col gap-1 border-b border-line">
                            <label className="text-ink-secondary font-black text-[9px] uppercase tracking-tighter">{t('moveAsset.moveReason')}</label>
                            <input
                                className="outline-none font-bold text-ink bg-transparent py-1 text-xs"
                                placeholder={t('moveAsset.moveReasonPlaceholder')}
                                value={formData.memo}
                                onChange={(e) => handleInputChange('memo', e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* Action Footer */}
                <div className="bg-surface-panel p-4 border-t border-line flex justify-end gap-3 shadow-inner">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 text-[10px] font-black uppercase text-ink-secondary hover:bg-surface-card border border-transparent hover:border-line transition-all"
                    >
                        {t('moveAsset.cancel')}
                    </button>
                    <button
                        onClick={handleMove}
                        className="bg-primary text-ink-inverse px-10 py-2 text-[10px] font-black uppercase flex items-center gap-2 hover:bg-primary-hover shadow-xl transition-all"
                    >
                        <Save size={16} /> {t('moveAsset.executeMove')}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ???? ????? ?????? ????? ???? ???????? ???????
const EditableField = ({ label, value, onChange, onSearch, icon, desc, type = "text" }) => (
    <div className="flex flex-col gap-1 border-b border-line group hover:border-primary transition-all">
        <label className="text-ink-secondary font-black text-[9px] uppercase tracking-tighter flex items-center gap-1">
            {icon} {label}
        </label>
        <div className="flex items-center justify-between pb-1">
            <input
                type={type}
                className="outline-none font-black text-primary bg-transparent w-full text-xs uppercase"
                value={value || ''}
                onChange={e => onChange && onChange(e.target.value)}
            />
            <div className="flex gap-3">
                {desc && <span className="text-[9px] text-ink-secondary font-normal italic whitespace-nowrap hidden md:block">{desc}</span>}
                {onSearch && (
                    <Search
                        size={15}
                        className="text-primary cursor-pointer hover:text-primary-dark hover:scale-110 transition-all"
                        onClick={onSearch}
                    />
                )}
            </div>
        </div>
    </div>
);



export default MoveAssetModal;